<template>
  <div id="app">
    <headerApp></headerApp>
    <div class="text-center logo_app2 logo_other">
           <img :src="get_setting_app.logo" alt="logo">
            <!-- <img
                    src="@/assets/logo_smile.png"
                    alt="logo"
                > -->
       </div>
    <router-view></router-view>
   <sidebarcart></sidebarcart>
   <!-- <footerApp></footerApp> -->
    <div class="mobile_nav">
      <div class="flex_nav_app">
         <span  uk-toggle="target: #offcanvas-sidebar"><ion-icon name="grid-outline"></ion-icon></span>
         <router-link to="/"><ion-icon name="home-outline"></ion-icon></router-link>
          <template v-if="authenticated && all_data_cart.status==402">
           <a  uk-toggle="target: #offcanvas-flip" class="button is-light cart_btn">
                      <i class="fas fa-shopping-basket"  aria-hidden="true"></i>
                       <span class="cart_no">0</span>
            </a>
          </template>
          <template v-else-if="authenticated && all_data_cart.status!=402">
            <a  uk-toggle="target: #offcanvas-flip" class="button is-light cart_btn b-cart">
                      <i class="fas fa-shopping-basket"  aria-hidden="true"></i>
                       <span class="cart_no">{{get_count_cart}}</span>
            </a>
             <!-- <a uk-toggle="target: #offcanvas-flip"><ion-icon name="basket-outline"></ion-icon></a> -->
          </template>
          <template v-else>
             <router-link to="/login"><ion-icon name="person-outline"></ion-icon></router-link>
          </template>
      
      </div>
    </div>
   <div v-if="loader" id="loader"></div>
  </div>
</template>

<script>
import headerApp from '@/components/global/headerApp.vue';
import sidebarcart from '@/components/global/sidebar_cart.vue';
// import footerApp from '@/components/global/footer.vue';
import {mapGetters} from 'vuex';
export default {
  name: 'App',
  components: {
    headerApp,
    sidebarcart,
    // footerApp
  },
  data(){
    return{
      loader:true
    }
  },
     computed:{
    ...mapGetters({
        authenticated:'auth/authenticated',
        user:'auth/user',
         get_setting_app:'get_setting_app',
         get_count_cart :'get_count_cart',
          all_data_cart:'all_data_cart',
    })
    } ,
  methods:{
    hide_loader(){
      setTimeout(()=>{
        this.loader = false;
      },600)
    }
  },
  mounted(){
    this.hide_loader();
  }
}
</script>
<style lang="scss" scoped>
.mobile_nav{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: var(--active_color);
    box-shadow: 0px 4px 7px 0px black;
    z-index: 9999;
.flex_nav_app{
    display: flex;
    justify-content: space-around;
    padding: 10px;
    align-items: center;

  ion-icon{
    font-size: 23px;
    color:black;
    transition: 0.2s ease-in-out;
    &:hover{
    transform: scale(1.2);
    }
  }
  i{
    font-size: 21px;
    color:black;
    transition: 0.2s ease-in-out;
    &:hover{
    transform: scale(1.2);
    }
  }
  .cart_no{
      background-color: black;
    color: white !important;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    font-weight: 600;
    top: 3px;
    right: -22px;
    font-size: 14px;
    box-shadow: 0px 0px 2px #363636;
    position: absolute;

     }
}

}
</style>